export const ToysSvg = () => <div>
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#999999"><path d="M600-280H120v-400h720v160h-60v-100H180v280h420v60Zm-420-60v-280 280Zm600 180v-120H660v-60h120v-120h60v120h120v60H840v120h-60Z"/></svg>
    </div>